module.exports = __webpack_public_path__ + "static/media/Substance_use.fce9ff18.png";